import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import { getMonthDateRange, listenMetabaseMessages } from "../../../utils/dateRange";

const MBBenefictsMasive = () => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    const { desde, hasta } = getMonthDateRange();

    const dashboardUrl = `https://minimalartco.metabaseapp.com/public/question/1e4ad301-7c28-4b46-bc59-020544070bd3?desde=${encodeURIComponent(desde)}&hasta=${encodeURIComponent(hasta)}`;
    setUrl(dashboardUrl);
  }, []);

  useEffect(() => {
    const cleanup = listenMetabaseMessages();
    return () => cleanup && cleanup();
  }, []);

  return (
    <React.Fragment>
      <Helmet title="Resumen" />
      <Container fluid className="p-0 mco-fade-in">
        <Row>
          <Col lg="12" className="mt-2">
             {url && (
              <iframe
                src={url}
                frameBorder="0"
                width="100%"
                height="1920"
                allowTransparency
              ></iframe>
            )}
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default MBBenefictsMasive;
